// eslint-disable-next-line import/prefer-default-export
export enum Store {
  default = 'default',
  en = 'luxeu_en',
  de = 'luxeu_de',
  fr = 'luxeu_fr',
  es = 'luxeu_es',
}
